<nav class="figma-benin-nav">
  <div class="container-fluid d-flex justify-content-center align-items-center h-100">
    <a href="/">
      <img src="assets/imgs/Zumeralogo-WHITE.png" alt="Zumera" class="img-fluid nav-logo">
    </a>
  </div>
</nav>
